import {
  Box,
  HStack,
  IIconProps,
  Pressable,
  usePropsResolution,
} from 'native-base';
import React from 'react';

import { cloneElementWithProps } from '../../../utils/component';
import type { ITabProps } from './Tab.types';

const Tab = (
  { icon, isHovered: isHoveredProp, label, ...props }: ITabProps,
  ref: any
) => {
  const {
    _pressableHover,
    _icon,
    _iconHover,
    _label,
    _labelHover,
    ...resolvedProps
  } = usePropsResolution('Tab', {
    icon,
    label,
    ...props,
  });

  const { styledIcon, styledHoveredIcon } = React.useMemo(() => {
    if (icon && React.isValidElement(icon)) {
      const clonedIcon = cloneElementWithProps<IIconProps>(
        icon,
        _icon,
        'tab-icon'
      );
      const clonedHoverIcon = cloneElementWithProps<IIconProps>(
        clonedIcon,
        _iconHover,
        'tab-icon'
      );
      return {
        styledIcon: clonedIcon,
        styledHoveredIcon: clonedHoverIcon,
      };
    } else {
      return { styledIcon: undefined, styledHoveredIcon: undefined };
    }
  }, [_icon, _iconHover, icon]);

  return (
    <Pressable
      {...resolvedProps}
      ref={ref}
      _hover={_pressableHover}
      _pressed={_pressableHover}
      isHovered={isHoveredProp}
    >
      {({ isHovered, isPressed }) => (
        <HStack>
          {styledIcon
            ? isHovered || isPressed || isHoveredProp
              ? styledHoveredIcon
              : styledIcon
            : undefined}
          {label && (
            <Box
              _text={
                isHovered || isPressed || isHoveredProp
                  ? { ..._label, ..._labelHover }
                  : _label
              }
            >
              {label}
            </Box>
          )}
        </HStack>
      )}
    </Pressable>
  );
};

export default React.memo(React.forwardRef(Tab));
